import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ApplicationState } from '../reducers/application.reducer';

export const selectApplicationState = createFeatureSelector<ApplicationState>('application');

export const selectApplication = createSelector(selectApplicationState, state => state.application);

export const selectServiceAttachmentPositions = createSelector(selectApplicationState, (state) => state.serviceAttachmentPositions);

export const selectApplicationList = createSelector(selectApplicationState, state => state.applicationList);

export const selectLoading = createSelector(selectApplicationState, state => state.loading > 0);

export const selectPending = createSelector(selectApplicationState, state => state.pending > 0);

export const selectRoadOccupationTypes = createSelector(selectApplicationState, state => state.roadOccupationTypes);

export const selectPayment = createSelector(selectApplicationState, state => state.applicationPayment);

export const selectShipments = createSelector(selectApplicationState, state => state.shipments);

export const selectShipmentById = (uuid?: string) => createSelector(selectApplicationState, state => state.shipments.filter(v => v?.uuid === uuid)[0] || null);

export const selectShipment = createSelector(selectApplicationState, state => state.shipment);

export const selectTreeRemovalReasons = createSelector(selectApplicationState, state => state.treeRemovalReasons);

export const selectEntityTypes = createSelector(selectApplicationState, state => state.entityTypes);
